<template>
    <v-panel
        v-model="panelOpen"
        class="v-image-cropper-panel"
        :title="panelTitle"
        :width="panelWidth"
        :max-height="panelHeight"
        :min-height="panelHeight"
        :mask-closable="false"
        @close="handleCancel"
    >
        <div class="v-image-cropper-panel-bd">
            <v-image-cropper
                v-model="currentValue"
                :kind="kind"
                :width="width"
                :height="height"
                :ratio="ratio"
                :keep-ratio="keepRatio"
                :src="url"
            >
            </v-image-cropper>
        </div>
        <div class="v-image-cropper-panel-ft">
            <v-button
                kind="primary"
                size="large"
                class="v-image-cropper-panel-ft-confirm"
                :loading="cropping"
                @click="handleConfirm"
                >确定</v-button
            ><v-button size="large" class="v-image-cropper-panel-ft-cancel" @click="handleCancel">取消</v-button>
        </div>
    </v-panel>
</template>

<script>
export default {
    name: 'Cropper',

    model: {
        prop: 'value',
        event: 'input'
    },

    props: {
        value: {
            type: Object,
            default: {}
        },
        panelTitle: {
            type: String,
            default: '图片裁切'
        },
        panelWidth: {
            type: Number,
            default: 630
        },
        panelHeight: {
            type: Number,
            default: 610
        },
        panelOpen: {
            type: Boolean,
            default: false
        },
        width: {
            type: Number,
            default: 630
        },
        height: {
            type: Number,
            default: 410
        },
        url: {
            type: String,
            default: ''
        },
        kind: {
            type: String,
            default: 'rectangle'
        },
        ratio: {
            type: Number,
            default: 0.75
        },
        keepRatio: {
            type: Boolean,
            default: false
        },
        cropping: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            currentValue: this.value,
            cropperOpen: true
        };
    },

    watch: {
        value(nextValue) {
            this.currentValue = nextValue;
        }
    },

    methods: {
        handleConfirm() {
            this.$emit('confirm', this.currentValue);
        },

        handleCancel() {
            this.$emit('cancel');
        }
    }
};
</script>

<style lang="less">
.v-image-cropper-panel {
    &-bd {
        margin-bottom: 30px;
    }

    &-ft {
        &-confirm,
        &-cancel {
            margin: 0 10px;
        }
    }

    .v-image-cropper__toolbar {
        display: none;
        .v-icon {
            margin: 10px;
            cursor: pointer;
            &:hover {
                color: #0067ed;
            }
        }
    }
}
</style>
